import { useLogin } from "@/context/useLoginProps";
import { getSiteProps, prepareRightFooterData } from "@/utils";

import { getFooterData } from "@/components/common/Footer/query";
import { RightFooterData } from "@/components/common/Footer/types";

import { countryDropdown, getRecruiterLogin } from "../loginMap";
import LoginLeftFooter from "./loginLeftFooter";
import LoginRightFooter from "./loginRightFooter";
import Skeleton from "./skeleton";

const LoginFooter: React.FC = () => {
  const { data, isLoading, isError } = getFooterData();
  const { hostname, isMobile } = useLogin();
  const siteProps = getSiteProps(hostname);

  if (isLoading) return <Skeleton />;
  if (isError) return <div>Error loading data. Please try again later.</div>;

  const rightFooterData: RightFooterData = prepareRightFooterData(
    data?.MODULE_RIGHT_FOOTER_REACT_CORE || [],
    hostname,
  );

  const { country_list, stay_connected, mail, contact_info } = rightFooterData;
  const recruiterLogin = getRecruiterLogin(siteProps?.site_map || "");

  let countryList = country_list.map((country) => {
    return {
      id: country.id,
      text: country.name,
      value: country.value,
    };
  });

  let selectedCountry = countryList.find((country) => {
    if (!siteProps?.site_map) return false;
    const countryId =
      countryDropdown[siteProps.site_map as keyof typeof countryDropdown];
    return country.id === countryId;
  });

  return (
    <footer className="flex max-md:!w-full max-md:flex-col-reverse">
      <div
        className={`flex w-1/2 flex-col items-start justify-end bg-neutral-100 pl-[120px] max-md:!w-full max-md:!items-center max-md:!justify-center max-md:!pl-0 ${isMobile ? "border border-t border-[#DEDDDD]" : ""}`}
      >
        <LoginLeftFooter
          selectedCountry={selectedCountry}
          countryList={countryList}
        />
      </div>
      <div className="flex flex-col justify-between max-md:bg-neutral-100 md:!w-1/2">
        <LoginRightFooter
          recruiterLogin={recruiterLogin}
          socialLink={stay_connected}
          contactInfo={contact_info}
          mail={mail}
        />
      </div>
    </footer>
  );
};

export default LoginFooter;
